
import React from 'react';

const StepperConnector: React.FC = () => {
  return <div className="h-2 w-full bg-gray-200 mx-1 rounded-full"></div>;
};

export default StepperConnector;
